import { CompetitionAvatar } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { Trans, useTranslation } from 'react-i18next';
import { secureBucketCookieRequestedAtom } from '@/atoms/cookies';
import { HomeDefaultTeamCompetition } from '@/atoms/home/defaultTeamCompetition';
import { classicCompetitionLeagueTableUrl } from '@/utils/classicLinks';
import { QuickStartCard } from './QuickStartCard';

// Competition pages only exist in Classic, so this is Home's one deliberate link there.
export const CompetitionCard = ({
  competition,
  teamName,
}: {
  competition: HomeDefaultTeamCompetition;
  teamName: string;
}) => {
  const { t } = useTranslation('home');
  const secureBucketCookieRequested = useAtomValue(secureBucketCookieRequestedAtom);

  return (
    <QuickStartCard
      avatar={
        <CompetitionAvatar
          competitionId={secureBucketCookieRequested ? competition.datahubId : undefined}
          size="small"
        />
      }
      title={competition.name}
      description={
        <Trans t={t} i18nKey="quickStart.competition" values={{ teamName }} components={{ bold: <strong /> }} />
      }
      href={classicCompetitionLeagueTableUrl(competition.classicId)}
    />
  );
};
